// extracted by mini-css-extract-plugin
export default {"confirm-body":"confirmationplaceholder_confirm-body__-dgnQ","confirm-text":"confirmationplaceholder_confirm-text__vtTwb","buttons":"confirmationplaceholder_buttons__iGaoI"};